// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__Jb5Cn","options":"AnswerScale_options__3oa5V","selected":"AnswerScale_selected__9aNoc"};